export default "__VITE_ASSET__SaCp2N7x__"